export function formatCurrencyCOP(amount) {
    const n = Number(amount) || 0;
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
}

export function formatCurrencyAbbreviated(amount) {
    const n = Number(amount) || 0;
    if (n >= 1000000) {
        return `$${(n / 1000000).toFixed(1)}M`;
    }
    if (n >= 1000) {
        return `$${Math.round(n / 1000)}k`;
    }
    return `$${n}`;
}
